import {Component} from '@angular/core';
import {PRODUCTION, SYSTEM_VERSION, AMBIENT} from '../../app.constants';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent {
  version: string = SYSTEM_VERSION;
  production: boolean = PRODUCTION;
  ambient: string = AMBIENT;
}
